import { useQuery } from '@tanstack/react-query'

import { baseClient } from '~/clients/api-client'

import { handleApiRequest } from '../../optimus/shared/apiWrapper'

// Polling interval for version checks (in milliseconds)
const VERSION_CHECK_INTERVAL_MS = 60_000 // 1 minute

export const useVersionQuery = ({ enabled = true }: { enabled?: boolean } = {}) =>
    useQuery({
        queryKey: ['api-version'],
        queryFn: () => handleApiRequest(() => baseClient.GET('/version')),
        refetchInterval: VERSION_CHECK_INTERVAL_MS,
        refetchIntervalInBackground: true,
        enabled,
    })
